import React from 'react'
import { useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'

import Select from '@/components/forms/Select'
import { FormField } from '@/components/forms/FormField'

import { getPlaybookVersionOptions } from '../playbook.helpers'

export const PlaybookVersionSelector = () => {
  const history = useHistory()
  const { section } = useParams()
  const {
    playbook: { id: playbookId },
    versions,
  } = useSelector((state) => state.playbook)

  const handleSelectPlaybookVersion = (value) => {
    history.push(`/playbooks/${value}/${section}`)
  }

  return (
    <div data-testid="playbook-version-selector" className="playbook-version-selector">
      <FormField>
        <Select
          options={getPlaybookVersionOptions(versions)}
          value={playbookId}
          isClearable={false}
          onChange={({ value }) => {
            handleSelectPlaybookVersion(value)
          }}
          fixedWidth
        />
      </FormField>
    </div>
  )
}
